import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'longText',
  standalone: false,
})
export class LongTextPipe implements PipeTransform {
  transform(text: string, length = 20, suffix = '...'): string {
    if (text?.length > length) {
      const truncated = text.substring(0, length).trim() + suffix;
      return truncated;
    }

    return text;
  }
}
